<template>
  <div class="el-dialog-tree-table">
    <el-button
      style="position: absolute;"
      plain
      type="single-number"
      @click="showDialogInventory()"
    >
      选择设备
    </el-button>
    <el-dialog
      maxHeight="null"
      width="1220px"
      title="物资清单选择"
      @close="close"
      :visible.sync="dialogFormVisible1"
      custom-class="sorting-code-number"
    >
      <div class="el-dialog__body-header">
        <span class="title">物装目录树</span>
        <el-search
          :formProp="formData"
          :showIndex="0"
          width="380px"
          placement="bottom-start"
          @search="search"
          @change="change"
        >
          <template slot="search">
            <el-input
              v-model="formData.matNum"
              clearable
              searchLabel="物装编码"
              placeholder="请输入内容"
            ></el-input>
            <el-input
              v-model="formData.matName"
              clearable
              searchLabel="物装名称"
              placeholder="请输入内容"
            ></el-input>
          </template>
        </el-search>
      </div>
      <div class="el-dialog__body-bodys">
        <div class="bodys-left">
          <el-tree
            :props="treeProps"
            :load="loadNode"
            ref="tree"
            node-key="categoryCode"
            :default-checked-keys="[1]"
            :expand-on-click-node="false"
            :check-strictly="true"
            :conditionCheckbox="true"
            show-checkbox
            @check="handleCheckClick"
            draggable
            lazy
            show-line
          >
          </el-tree>
        </div>
        <div class="bodys-right">
          <el-table
            :data="tableData"
            maxHeight="390"
            ref="multipleTable"
            :lineClamp="lineClampBody"
            style="width: 400px"
            @select="handleSelect"
            @select-all="handleSelectAll"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column prop="matCode" label="物装编码"> </el-table-column>
            <el-table-column prop="matName" label="物装名称"> </el-table-column>
            <el-table-column prop="unitStr" label="单位"> </el-table-column>
            <el-table-column prop="parentCategoryName" label="大类名称">
            </el-table-column>
          </el-table>
          <div class="table-footer" style="height:30px" v-if="isTurnPage">
            <div class="ccui-table-footer">
              <div id="ccui-paging">
                <el-pagination
                  :total="total"
                  :pager-count="5"
                  :page-size="formData.pageSize"
                  :current-page="formData.pageNo"
                  prev-text="< 上一页"
                  next-text="下一页 >"
                  background
                  layout="pager, jumper"
                  popper-class="ccui-paging-page-size-popper"
                  @prev-click="handlePrev"
                  @next-click="handleNext"
                  @size-change="handleSizeChange"
                  @addCurrentPage="internalCurrentPage"
                  @current-change="handleCurrentChange"
                />
                <el-button
                  class="ccui-pagination-btn"
                  size="mini"
                  type="default"
                  @click="handleGoPage"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bodys-right">
          <el-table
            :data="rightTableData"
            maxHeight="390"
            :lineClamp="lineClampBody"
            style="width: 513px"
            :row-key="getRowKeys"
            :reserve-selection="true"
            @select="handleSelect"
            @select-all="handleSelectAll"
          >
            <el-table-column prop="matCode" label="物装编码"> </el-table-column>
            <el-table-column prop="matName" label="物装名称"> </el-table-column>
            <el-table-column prop="unitStr" label="单位"> </el-table-column>
            <el-table-column prop="parentCategoryName" label="大类名称">
            </el-table-column>
            <el-table-column prop="" label="数量" width="50">
              <template slot-scope="scope">
                <el-input
                  @input="
                    scope.row.quantity = Number(
                      $event.target.value.replace(/\D+/, '')
                    )
                  "
                  :title="scope.row.quantity"
                  v-model="scope.row.quantity"
                  class="input-short"
                />
              </template>
            </el-table-column>
            <el-table-column prop="date" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="tableDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="cancel"
          >取 消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="handleTrue"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listMatSubCataTree, listMateriaCata } from "../../api/";
export default {
  name: "ElDialogTreeTable",
  watch: {
    dialogFormVisible(item) {
      this.dialogFormVisible1 = item;
    },
    tableData(item) {
      this.$nextTick(() => {
        item.map(e => {
          this.rightTableData.map(i => {
            if (i.matCode === e.matCode) {
              this.$refs.multipleTable.toggleRowSelection(e, true);
            }
          });
        });
      });
    },
    materialsData(e) {
      this.rightTableData = [];
      e.map(item => this.rightTableData.push(item));
      this.rightTableData.map(item => {
        item.quantity = "1";
      });
      // this.rightTableData = JSON.parse(JSON.stringify(this.rightTableData));
      this.rightTableData = this.unique(this.rightTableData);
    }
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  data() {
    return {
      lineClampBody: true,
      dialogFormVisible1: this.dialogFormVisible,
      conditionCheckbox: true,
      tableData: [],
      rightTableData: [],
      treeProps: {
        label: "categoryName",
        children: "childNodes",
        isLeaf: "isLeaf"
      },
      gridData: [],
      dialogTableVisibletextarea: false,
      formData: {
        matName: "",
        matNum: "",
        pageNo: 1,
        pageSize: 10,
        catalogId: ""
      },
      textarea: "",
      formLabelWidth: "120px",
      present: "",
      total: 0,
      lastTime: {
        button: false
      },
      materialsData: [], // 物资选择数据
      isTurnPage: false, // 是否有翻页
      treeArray: []
    };
  },
  methods: {
    // 表格删除
    tableDelete(row) {
      this.rightTableData = this.rightTableData.filter(
        item => item.matCode !== row.matCode
      );
      // this.tableData = JSON.parse(JSON.stringify(this.tableData))
      let a = this.tableData.filter(item => item.matCode === row.matCode);
      this.$nextTick(() => {
        this.$refs.multipleTable.toggleRowSelection(a[0], false);
      });
    },
    showDialogInventory() {
      this.dialogFormVisible1 = true;
    },
    handleNodeClick(val, node, d) {
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree.setCheckedKeys([val.id]);
    },
    handleClick(val) {
      val.button = true;
      if (val.id !== this.lastTime.id) {
        this.lastTime.button = false;
        this.lastTime = val;
      }
    },
    handleSizeChange(val) {},
    getRowKeys(row) {
      return row.matCode;
    },
    close() {
      this.$emit("update:dialogFormVisible", false);
    },
    cancel() {
      this.dialogFormVisible1 = false;
      this.$emit("update:dialogFormVisible", false);
    },
    // 树复选框
    handleCheckClick(checkedNodes) {
      this.formData.matName = "";
      this.formData.matNum = "";
      if (this.treeArray.indexOf(checkedNodes.categoryCode) === -1) {
        this.treeArray.push(checkedNodes.categoryCode);
      } else {
        let index = this.treeArray.indexOf(checkedNodes.categoryCode);
        this.treeArray.splice(index, 1);
      }
      this.formData.catalogId = this.treeArray.join(",");
      if (checkedNodes.isLeaf) {
        this.qryListMateriaCata();
      }
    },
    qryListMateriaCata() {
      listMateriaCata(this.formData).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.total = res.data.data.recordsTotal;
          this.$nextTick(() => {
            if (this.tableData === []) {
              this.isTurnPage = false;
            } else {
              this.isTurnPage = true;
            }
          });
        }
      });
    },
    // 列表复选框全选
    handleSelectAll(selection) {
      this.materialsData = selection;
      this.$emit("handleSelectAll", selection);
    },
    // 列表复选框单选
    handleSelect(row, e, w) {
      this.$emit("handleSelect", row);
      this.materialsData = row;
    },
    handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.qryListMateriaCata();
    },
    internalCurrentPage(val) {
      this.formData.pageNo = val;
      this.qryListMateriaCata();
    },
    handlePrev(val) {},
    handleNext(val) {},
    handleGoPage() {},
    loadNode(node, resolve) {
      let data = {};
      if (node.level === 0) {
        data = {
          categoryCode: "0"
        };
      } else {
        data = {
          categoryCode: node.data.categoryCode
        };
      }
      listMatSubCataTree(data).then(res => {
        if (res.data.code === "0") {
          res.data.data.categoryList.forEach(item => {
            item.isLeaf = item.isLeaf === 1;
          });
          if (node.level === 0) {
            resolve(res.data.data.categoryList);
          } else {
            if (res.data.data.categoryList[0].categoryLevel === 4) {
              res.data.data.categoryList.map(item => {
                item.treeCheckbox = true;
              });
            }
            resolve(res.data.data.categoryList);
          }
        }
      });
    },
    search(val) {
      var arr = Object.keys(val);
      if (arr.length !== 0) {
        this.$refs.tree.setCheckedKeys([]);
        this.formData.catalogId = "";
        this.treeArray = [];
        this.qryListMateriaCata();
      }
    },
    change(val) {
      if (val === 0) {
        this.formData.matName = "";
      } else {
        this.formData.matNum = "";
      }
    },
    handleTrue() {
      this.dialogFormVisible1 = false;
      alert(JSON.stringify(this.rightTableData));
      this.$emit("handleTrue", this.rightTableData);
      this.$emit("update:dialogFormVisible", false);
    },
    unique(arr) {
      // 根据唯一标识orderId来对数组进行过滤
      const res = new Map(); // 定义常量 res,值为一个Map对象实例
      // 返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
      return arr.filter(
        arr => !res.has(arr.matCode) && res.set(arr.matCode, 1)
      );
    }
  }
};
</script>
<style scoped lang="scss">
.bodys-right {
  float: left !important;
  padding: 0 6px;
}
/deep/ .el-dialog__body {
  width: 1180px !important;
}
/deep/ .el-table__row {
  .el-input {
    input {
      background-color: #f1f1f1 !important;
      color: #9b9b9b !important;
      padding: 0 10px !important;
    }
  }
}
/deep/ .el-search {
  .ccui-search-wrapper {
    width: 51% !important;
  }
}
</style>
